<!-- 
    * 上半场和下半场出现伤停补时时，会自动将45|90改为45+|90+;
    * 如果上半场结束（没有伤停补时）【0...45...90】;
    * 如果上半场结束（有伤停补时）【0...45+...45...90】;
    * 如果下半场结束（有伤停补时）【0...45+...45...90+】; 
    * 如果有加时赛则（上下半场都有伤停补时）【0...45+...45...90+...90...105...120】,因为加时赛没有伤停补时;
    * 有伤停补时的情况以5为一个间隔单位，不足5的倍数的则补齐为5的倍数，比如上半场47分钟结束，则图表显示50分钟结束，自动补3分钟，主要是为了防止45+和45离的太紧，补的3分钟比赛态势值为0，事件都是null;如果51分钟结束则补到55分钟以此类推
    * 比赛态势通过取最大值*2来设置y轴的最大值和最小值，这样是为了保证事件图标永远不会触碰到图表的上下边界
   -->

<template>
  <div
    class="matchState_keyEvent_bar"
    :class="isAutoExportPng ? 'autoExportPng' : ''"
  >
    <!-- :style="{ width: `3400px` }" -->
    <div class="barEcharts">
      <!-- <div class="xAxisTip">
            <span
              v-for="item in xAxisData"
              :key="item"
              v-text="item"
              :style="{ color: otherColor[1] }"
            ></span>
          </div> -->
      <div
        ref="barEcharts"
        class="barEchartsDom"
        :style="{
          height: `${parentDomHPx ? parentDomHPx : '0'}`,
        }"
        @click="clickEchartBox"
      ></div>
    </div>
  </div>
</template>

<script>
// 比赛态势及关键事件
// import { dataList } from './keyEvent_bar.json' //测试数据
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'coordinateSystemScatter',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      homeBgColor: ['rgba(103, 5, 46, 0.5)', 'rgba(235, 27, 80, 1)'], //主队：【背景色，覆盖色】 该主题没有用到背景色
      awayBgColor: ['rgba(28, 136, 152, 0.5)', 'rgba(0, 207, 183, 1)'], //客队：【背景色，覆盖色】该主题没有用到背景色
      otherColor: ['rgba(133, 20, 54, 1)', 'rgba(255,255,255,1)'], //[中间刻度线背景颜色，分钟刻度字颜色]
      initFlag: false,
      myChart: null,
      xAxisData: [],
      yAxisMaxNum: 1,
      yAxisMaxMin: [1, -1],
      maxMinTime: 90,
      homeData: [],
      awayData: [],
      xAxisTimeInterval: 5,
      parentDomHPx: null,
      eventReplaceCode: 1016,
      iconBase64: {
        point:
          'image://data:image/png;base64,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',
        goal: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAAFKCAMAAABM9+Y3AAAAq1BMVEUAAADAFkqaFT3/F1+FFDb99oGHGDeJGzj884Dr1HWRKT2LHzn05Xv68X+TLj6NIjv57n7u2XfoznSbPEOWM0Dy4Hr26HyPJjyxZ1KhR0fmynLWrWmYOEL4633w3HjRomWeQkWnVEujTUmsXk7KlmGvYlDTp2fNnGOqWU23clXEil28fFjbtmviwm/ZsWrIkV+/gFq0bVPfvm7duW3q0XXBhVu6d1fkxnHGjV7FvA9TAAAABHRSTlMAf79A+b+6EAAAEn1JREFUeNrs2m0KwjAQhOHsx/3PbIkgFWmTVMGZ7bxHeJiN/WFDLCLMvJf7fMu2IpoaEVrXm6mjivQAMa/kAt0pviHK81phnj/rvpwRL0ZxftHKUa9ztrv0OUdpgjo+8+Kap47SBHWse+nhnv+pGObiIDXNo2wdUtOEG2QhTBRI+jtHgqTGRIOkxUSEpMREheT7AQKG5MK0hI8DE/m2qTBJIAksCW6bA5NnkuiYbJCwlpGUAWISThLTku6VhMWk+uFGtqSeZM9B/tNBPkmgYZaQRLDkP26UIyf9mAQcZpHjBrAsc9zrlnomR3mbS8/kRNFm0jMJeeRlJUeWkoS1LC15ZilJWMuCH0FzH0WSfLBjL8qJwlAAhkc4J0ZFBRFUrkVWELRabNW+/5PtznTa6c2aYIB09XsAHf85B2KkbXkVJb9reSspbcurKfm55a2ktC2vquTHlrfzpKTny6sr+dryVlLalldZEqB1Kylvy//0zryJe3W4YuqvOlB2l/nzDEow8+d4ANVSfs2DknjT0DE0YwolxCM7cJLCJFAh5VeUJF6ROIFPEfv7NnAjKx2R6tbIzbwKa7bkL9mN02Og44t0ANwmW3yhB064qG7TVblf3uRuvzN8iq82d8DNS/CNb+zyWRuqoUr8yhnGoaNRfOcYAbf5Dt+hmpMsJlAFRdr17hbuk48fdRbAbengR3pnk1Wy5y05Sw4Oa6OPn1kZcJsa+Bk1HldjEK8l4YPyX8iA4lf+CrhlGn5Fg0piqrI9KCfZJqD4HfoA3A42fstaH7ogmCLXevcWiYGn7IHbSscTAnc6BLFaEpVsz9MRRZEpH3Q8hXbSqA1CqbJcYpDxw72OiIKn8rT+cS/2L5AiyVAOF66FP+kLe1a+0dzpBARSZCjZNvMRxR/ZB+BWWPizp+2dyC1Xm1/v4WJj4xlWAdymHTzDXwsdzKaHknj7EZ71FAO36MjwubkpbjCVZkv2okTD8+7nwG22xvNsdzkEUdQG15t0i3uKDFwTuI1DZECPhwEBMZTmhpKYuYFM/kyAWy+nyCLYClvyVlND2ZuHNjLxDwT4ZRoy8ZOoB2KozQzlMF73kc0ohhKiI7KhO1E3mUojJbvFEVm5JpQwDpHV6DAAIdT615sMVh1k1d+XWsD2ykdWxn5MQACl9qEk4zxAZp0YSokcZGZtPSEtWzUPJfH+aMgu8aCUQUqRmZ2KeZHXO5TETG1kp2UlfyMpLGTnh0L+kit1DiUxQx85rGdQkukiBz0R0lKtayj5S9qrIZTUzjTk0HdnAloq0pbExxmUZrqUr+UdgYupdaX0OEtqWQ9Ka08t5Ntx8/KWSk0lx6mNPGhiXvZ1fb6WoYAzkVpLyu5WQy6dJYFLRA5ysdMBXEqpo+TwL3t3op0oDIUB+AzcmyD7pogLIopLXevY2vd/slnPnFkcCJCYzJl+D1Dav7nkIjF56Tf8y3ZJxytubWzEPpnQlS4+Sus1wEac2QQ6ipc+NpKdLehIE54kLUNsxDik0Fn+0cBGes8UOtIFR0nSQ8Mkezxe/JNi1DDL25xAN5rgB5346GAjWUmBA7oJmmVpfIygI13ooPTWU2ykP7SAC7rIjIbtZQLdaCIHJdll2ITRL1slyWVc9p8IdCNyUM7DZkkGGwrckPm1WZa9Err5IG5Qug3n0VtOgCMSNbz+YQKdaOIGZbNp1Fi7wJl5crCBcA7d6OKayng2QFbZ0APurEUPWU3Hkbh+CDqjJePAdNYxAQGIe/KRhRE+WwS60kW+h3B3vfowjWNqgSBWPjZY3j66It9MABc03oVGzYevhUdAGOKlKx+rGNfzhBLgQBO8Sshyy7GNfxM85R4BoYgXvVzxb+zj0LWAE130Il+aRM+rOx2zMzrNTYuAeJZZvN1Z+W5k422UUOBGe8Aafitx0+1yH9oOfuFnt/FTGbkehQchnjlZvKwOwbdAHTvcL7dFnHD+T4peef4jTtONJ1Ga5tEkdk2PEngs6pluHEd5muZffoFEQEHoj9zTgXwGTfxTv4H2vtEIN/r7PkK86P/7JoD8aO/1zY3+Xt/vUSpHe69vbt4HJTf6PxNlkhdFboK6tH+jvr3N2/hyOFzGp0VCQE3av7A7JS3Woyl+NQ1nGwpq0pWvb2K+Hhz8wbntXDUHpvJR0nwZ4C/661TJgakpfqv0Fscp/sbfDz1QkNK3ShKfR3hH+DJRsMh1hevbStd9vMuezS1QzQd1ozSHHx38C+fyrNzso6l6q6TR0xUrBG+5arOPordKb76ya/cVSUApuor1TdztwWDYVyRWqshVjJLmpwAZ9JepSrOPpt67iOR7M1nP35cKfcShqTbrkHg3QmbX80Sd2UexWed7M8nMnhXKPPvoSt0qvzeTDRgHZVpMlaKkk5ceNha8RWoU+Qd1Zh2vWA2whelxrkSLqSkz67jPIwNbMcJXFYpclShpdOpja/Y6V6DFVGMCTzZ7HztwLgv5Ra4rMOtUbDfGLDhLf45UIEorn9nY2WAs+znyg/Qok8XNQQ6McJgQkEiT3AsR96mPnNjLmIIs0qOk+d5HbvxLITFLTWovRDehgTz1SolZyoySzHvIWbAgIIvMttK9GciZEU5AFl1elGQ5QO6mMwKS6PJ6oThAAYIcpJAa5c5GAQZPIMkHeVEeHRTAOIAUMqMkVxQi8EAOTVqHngQoRBCDDDKjNAVFmU1ABplR0h4KEZggg8wo4SJm2hkRkEOT99z4NkABpmuQQmqU8wwF6JcgS9sovfP+OFueh4UJLXkjA/m7mtCSWQzPy9lxf/aggoAozbHj+wO7H/Qup9Il0IKIZ3C/3TO4uzhdelnfHvi+Mzahgogo9/idMcjC1bDF9TcZctcfQlPEHK7CbODgd/uHR/kRf+Jnt+aLmhMBFX51oRmav92yKf7ko9woEQ07bPr9JLKeImf+ikATNF2GtoGoVJSfDcJTRKCBMsOG+J71SqJTOEBE2VHu8U/2YWsCO3fEvb4nwM7cHmxEBaI84h1GNksJsCIzzhXujymwIvk6MPAn8qadMd41uJQesBpmnOt7C6y88uMA73p4M5TM8D7junOBUcy5wsMIGJmvoYP3VW2XLibKdcVK3BjYkNlUTn3HFefwrltHqUEr3qnqOzUTYPOcca3vHbCZnCquu3x4lGfkkOWEa4WHOTCJKxfGPnnQitY2SmtbfYxnDCzIykdunKMFLGqWfL1W/BQhUdKy5mggE1hsM471fQYWyS7AKsNHR0kKrHR9toBBxLHCwxQYWMMQK20oVBARZWTUvI+eE6hHVz6/+vagHinqzpnICbTQ5T24a9ee8AcMXjNu9f0CDOK6z1D8GCoIidIMa29dHtTLuVV4WEAdljPoAhfa+dB6JVuyxxqHOdSzxg5yYewTqFdcsMbBhApCovSWWGO6NKHero9c2E9QLzkNsMYsgXb01lFaO6wTlgRqpRUVzv3snE39xV4saEdvvYCabhjOujShlsenwg2Wz8YShpMzhxTa6LQWPaqPIFxAvTOXCrffoN78hnWMlEA7Hb5sYn6i7k6w2oaBMACPyi/JibGzOVuzNAsEh0AgC6H3P1lLeW0pTSxFIxLxHQD8JjOSLdmaoTSpXlVgNPFS4fUcRrHFCyGXKVzwvttp30kjmx6s7V7ko75TGDU2FlfchgNmKOPvNsteCkZPPr5xfIDZvCaNbipwwfvGUV9Lo8i8JG3b3Zs/Ksc2HdnnGm4E43tw1U8s6mUCo/Iy4td3BgNDfTNmHX4oUdlKo9ocZrfsCh88KBh1LK632YajC86BD/E3aTGHKxjl7ArfXuMV9xdbVuCIdaKLnkuzXhtGKbvC7/owimcW/+VRw4ARSt5NulyPYHbbYta3Te5nd9Iomii4+WJxZBNzsPyaw2xalyylDswmz9KoWYEjwTuTTV9Jo9oKZtmSWd8NmF1vpdEshgt+KFXua2/6+0AaWM5tzBv0joajC+ahi+0WYxnRX4WXVjCwXDZJMgVH3KNAdc9iRoCFjPMcHhnq2/75dK3hhn+qqupYFB8M2Ltll08KFiyWhRYKjgT7BOpy1RjKG9jIZpFzUi4bMLAMZZTBFT+UaukpKzG+j1y/xJvCwPZh517B1QX7iHl1HfFXv15N3b6XiLYdBQPLsTKaK7jy0A4zbhkHMlgyvDZheAnEbDE0FVAZbvz0kFA3kSw03MFWeVE6/oTAFLZWhr8e9RRcCR9NYrqJcc3GmmrnD5t6yVJ9czUtK1jL67JQksPZhY/WRcowxD1PcASlj6JwhNG9IcM1nPnpHTwvTstNhkCUl8VJ+QRnwk/HvHazeHMnjLO2AajirZ1WCkfeQomHpHgCD0bh20kJ5wSyC/JT4f3LwteGEIzCnc1BF+7IUyjVLCncKQhGuixIyjsNZ4LIU4V3WwWPjcEMlYAqeApv5XAnvDW11offRdt2EJDDq6LJJoY7Il8VjsnB0XIZzK3Qi7R3cHacwp0g8lbhulc9cIWPCgFRi6H/pPQbSkyacq91F0EZbQ785DkYiDxWuL4Z7N/XCaBNxlt6/0JbtRfD3Rcin2k5qn2GpDyUlsMJGITfUOrb1r4PdwJLSkDve+IZ3GgwEHmtcGTP0f/rfw0Epz/7/zrrDTB8IfKblmrVlO/UOwHdnv+mruvyncuFAoOgPcDR7g3ezzkBdaz8q/1+t6x6l4KDyHeFY7KN5BvJLMDyftF4t2RQy8EhiHxXOPTjpXxjPQ6wvF+o8fqf4nmIwSHoA9IyXVbfDpTB9P0s/LY+WffBQh8RSoz/tnwp7YIcKF+1d6U3bWUUOATtdwGW+LH5Zk81YOlj7U95V8BC9DFpmc4Grz912JH8G8vqsg8WQYdcgGdyn7yMk7vAIwmki+2v141y8Aj6qLRUq5JM7lcBj5O/lVfPkRzuNHjoMAGeyu22lwc7d79VyZe1qzJ4BBUAU9YZBXo/+Z4ezRtgogPCaXB9IgpMgg4Jo5fwJ0L02dJS6bhSicMbNwTRp0lLFaejSX692i0Wi928Mx13++2A9t0EfZK01Gk3313dfW1W/5y8Xlp/e7qe9CthhFMQfYa0VOVu52rvUdtJfbYbZyHsdAii8NNSZ+Pb56o8JKp964zOnpqCKPi01Nn021AWG2zmowrOShAFnpaqnFt1sU/W836M8xFEgadlZfS9Ju0MltOywrkIoqDTUpU7x3xUNrxtaJyHIAo6LXXjoSmPkdyNKzgLIgo5LePJ8YcGbudnKXJB1nAG8fReHq95myqcHNkTOLHXjUAXrasMpyaIKNwSj1cl5yaYmcJp0S+Bzjx6tZWuWjcpTkoQhZuWavpVOmBswTIIonDTUnXXzO4RGqdDvwQ682S9iHu8ncKJvCZlqCUe81u2rhs4Ffop2BJflTz0uo1xGoIo3LTsbyRfbY4TeBfJ0J55lJ+OzOs+ToF+CrbEx1+lD5cP+HivSRlqif9g5153E4ShAI5XbeUioIhhFkVuokCiExYz3//JBonDZBc1s2UH6f8RfvGc9kNF8iaESQ7FvKskAVsmU8Ime425h8rAjnj1o2SU42PO9dAleBf10CGs0jLMs7Mk3BE/aYRV8k7FPOujMrgjrhYyYZYZY54NUBncEY8Uwi7XwxzrIQTacm0TdsnvBuZULQl2XY5ZzjeZvFmYT/WihLsuh8FW0QmTZNOLOb7XGCDolpLh556pP+64SanBDbIeb+DrcjSj+dZxH5jr6TanszHmVi0JfF1WjQw/Oi7+Muq6uc8iyvm9ZSXZGkuMpRcrnB8XjiaTe7OdRTYPLe7PM+ojB/y6vCSpS5qk2aZQbHI119xtTmlCLVXCDYRQ+yyrKs8gyg+v3r5wlJXm6jIpk3VXWylOsffWh7R64K9KQ9xM9eHdiqPnW9LYWFo0DJIonp+LoyQIqb80Gn473UOo3ZZgqiSFJVjJTlp+SgpLsJIQ/tPTaH10SViCleyU5VdJYQlWsjOWP0kKS7CSnbD8XVLcL8HcJztmeU1SWIKVfGrLW5LCEqzk/38YglMDdF/iUnSj/v2SYshhXCef3vKj3TrIQRiIYSjaONz/zCAWwKJFUVup32l8hCd7MrHUM5a8Z/KTbPNgaofkFBM37laWCMkOIweMu0kxIZX0twRV0hxTCy6mlrRK2mICK+lpiXslbTFRh9sZE11JJ0sDSBNM+rZtMLF32w3TZNvfBBTTDpKKaQlJxLSFpGFaQ5IOkD8kA1M+/0j2znsU8vpqqhtkuZpTyGJCj+2MI1RT2RxyfenjyNRseWf+J9+cU0cip+KujD+cOqx43zae5ynFKK6DhlQ0HMRKMuMVbbQwkkn4BGDkPcsgxYZiAAAAAElFTkSuQmCC',
        ownGoal:
          'image://data:image/png;base64,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',
      },
      combatObj: [
        {
          logo: 'https://images.mixtmt.com/img-euro/teams/TUR/TUR_240x240.png',
          name: '俄罗斯',
          id: '1',
        },
        {
          logo: 'https://images.mixtmt.com/img-euro/teams/TUR/TUR_240x240.png',
          name: '美国',
          id: '2',
        },
      ],
    }
  },
  created() {
    if (this.currThemeObj && this.currThemeObj.cssStyle) {
      const cssStyle = this.currThemeObj.cssStyle
      // console.debug("cssStyle:", cssStyle)
      this.homeBgColor = [
        'rgba(103, 5, 46, 0.5)',
        cssStyle.echarts_keyEventBar_homeColor,
      ]
      this.awayBgColor = [
        'rgba(103, 5, 46, 0.5)',
        cssStyle.echarts_keyEventBar_awayColor,
      ]
      this.otherColor = [
        cssStyle.echarts_keyEventBar_otherColor_0,
        cssStyle.echarts_keyEventBar_otherColor_1,
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchartFlag()
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.xAxisTimeNumArr = []
    this.xAxisData = []
    this.homeBgData = []
    this.awayBgData = []
    this.homeData = []
    this.awayData = []
    this.totalTimeMinArr = []
  },
  components: {},
  watch: {
    datas(val) {
      if (this.initFlag && this.myChart) {
        this.initdata(val.data.dataList)
        this.initEcharts()
      }
    },
  },
  methods: {
    initEchartFlag() {
      setTimeout(() => {
        if (this.$refs.barEcharts && this.$refs.barEcharts.clientWidth) {
          this.parentDomHPx = `${Math.ceil(
            this.$refs.barEcharts.clientWidth / 2.48
          )}px`
          this.$nextTick(() => {
            this.initdata(this.datas.data.dataList)
            // this.initdata(dataList) //测试数据入口
            this.initFlag = true
            this.initEcharts()
            // this.myChart.on('click', 'series.line', (params) => {
            //   console.debug(params)
            //   if (params.componentType == 'markPoint') {
            //     // 点击了 markPoint
            //     this.isMarkFlag = true
            //   }
            // })
          })
        } else {
          this.initEchartFlag()
        }
      }, 50)
    },
    initdata(dataList) {
      // this.homeData = [
      //   0, 0, 0, 0, 5, 30, 10, 28, 42, 59, 20, 0, 0, 0, 0, 0, 3, 50, 42, 60,
      // ]
      // this.awayData = [
      //   0, -11, -13, -35, 0, 0, 0, 0, 0, 0, 0, -10, -50, -10, -15, -100, 0, 0,
      //   0, 0,
      // ]
      let homeData = []
      let awayData = []
      let homeEventData = []
      let awayEventData = []
      const initSwitchCourtEndMinArr = [45, 90, 105, 120]
      const switchCourtEndMinArr = []
      if (dataList && dataList.length > 2) {
        // 进入了加时赛
        this.maxMinTime = 120
      } else if (dataList && dataList.length == 0) {
        this.maxMinTime = 90
      }
      const totalTimeMinArr = []
      const dom = this.$refs.barEcharts
      const width = dom.clientWidth
      const height = dom.clientHeight
      let timeBgWidth =
        Math.floor(width * 0.035) % 2 == 0
          ? Math.floor(width * 0.035)
          : Math.ceil(width * 0.035)

      let yAxisMaxNum = 0
      let realityMaxNum = 0
      if (!dataList || dataList.length == 0) {
        dataList = []
        dataList.push({
          period: 1,
          list: [
            {
              matchPeriod: 1,
              matchMinute: 1,
              homeMomentum: 0,
              awayMomentum: 0,
              combinedMomentum: 0,
              goal: null,
              type: null,
            },
          ],
        })
      }
      dataList.forEach((group, gIndex) => {
        if (group.list && group.list.length > 0) {
          const periodHomeData = []
          const periodAwayData = []
          let endMin =
            group.list[group.list.length - 1] &&
            group.list[group.list.length - 1].matchMinute
              ? group.list[group.list.length - 1].matchMinute
              : null
          if (!endMin) {
            if (initSwitchCourtEndMinArr[gIndex]) {
              endMin = initSwitchCourtEndMinArr[gIndex]
            } else {
              console.debug('比赛阶段数据超出了加时赛')
            }
          }
          switchCourtEndMinArr.push(endMin - 0)
          group.list.forEach((item) => {
            const curNum = Math.ceil(
              Math.abs(
                item.combinedMomentum - 0 ? item.combinedMomentum - 0 : 0
              )
            )
            if (curNum > realityMaxNum) {
              realityMaxNum = curNum
            }

            if (item.combinedMomentum > 0) {
              periodHomeData.push(item.combinedMomentum)
              periodAwayData.push(0)
            } else if (item.combinedMomentum < 0) {
              periodHomeData.push(0)
              periodAwayData.push(item.combinedMomentum)
            } else {
              periodHomeData.push(0)
              periodAwayData.push(0)
            }
            if (item.goal) {
              let cell = item
              cell.xAxistimeMinId = `${item.matchPeriod}_${item.matchMinute}`
              cell.eventCodeWeb = this.eventCode2eventCodeWeb(item.goal - 0)
              cell.timeMin = item.matchMinute

              if (item.type == 'on') {
                cell.homeAway = 'HOME'
                homeEventData.push(cell)
              }
              if (item.type == 'under') {
                cell.homeAway = 'AWAY'
                awayEventData.push(cell)
              }
            }
          })

          totalTimeMinArr.push(group.list ? group.list : [])
          homeData.push(periodHomeData)
          awayData.push(periodAwayData)
        }
      })

      yAxisMaxNum = Math.ceil(realityMaxNum * (realityMaxNum > 4 ? 1.2 : 1.3))
      this.realityMaxNum = realityMaxNum
      if (this.yAxisMaxNum <= yAxisMaxNum) {
        this.yAxisMaxNum = yAxisMaxNum
        this.yAxisMaxMin = [yAxisMaxNum, -1 * yAxisMaxNum]
      }
      this.yAxisBaseHeight =
        Math.round(
          (timeBgWidth / ((height / 100) * 88)) * this.yAxisMaxMin[0] * 10
        ) / 10 //Math.round(timeBgWidth/(height/100*88)*100)

      console.debug(
        'yAxisMaxNum:',
        realityMaxNum,
        yAxisMaxNum,
        this.yAxisMaxMin
      )
      const injuryTimeMinArr = [] //正值：该阶段伤停补时时间；负值：距离常规时间还差多少分钟结束该阶段
      if (this.maxMinTime == 90 && switchCourtEndMinArr.length == 1) {
        switchCourtEndMinArr.push(90)
      }
      if (this.maxMinTime == 120 && switchCourtEndMinArr.length == 3) {
        switchCourtEndMinArr.push(switchCourtEndMinArr[2])
      }
      switchCourtEndMinArr.forEach((item, index) => {
        injuryTimeMinArr.push(item - initSwitchCourtEndMinArr[index])
      })

      const realityPeriodArr = periodDataFormatHandler(
        initSwitchCourtEndMinArr,
        injuryTimeMinArr,
        this.maxMinTime
      )

      const xAxisTimeSeriesData = [] // [0...45...,45...90...,90..105..105...120]
      let isAddStartMin = 0 //换场时是否需要重新在起点画时间刻度
      realityPeriodArr.forEach((item, index) => {
        if (index === 0) {
          // 因为上半场和下半场有伤停补时，所以需要在开始补0占位；因为上半场有0是必须补0的，下半场要看上半场有没有伤停补时，有伤停补时补0，没伤停补时不补0
          homeData[index] = [].concat([0], homeData[index])
          awayData[index] = [].concat([0], awayData[index])
          totalTimeMinArr[index] = [].concat(
            [
              {
                matchPeriod: index + 1,
                matchMinute: item.minMix[0],
                homeMomentum: 0,
                awayMomentum: 0,
                combinedMomentum: 0,
                goal: null,
                type: null,
              },
            ],
            totalTimeMinArr[index]
          )
        } else {
          if (realityPeriodArr[index - 1].periodState == '3') {
            // 3代表伤停补时
            isAddStartMin = 0
            homeData[index] = [].concat([0], homeData[index])
            awayData[index] = [].concat([0], awayData[index])
            totalTimeMinArr[index] = [].concat(
              [
                {
                  matchPeriod: index + 1,
                  matchMinute: item.minMix[0],
                  homeMomentum: 0,
                  awayMomentum: 0,
                  combinedMomentum: 0,
                  goal: null,
                  type: null,
                },
              ],
              totalTimeMinArr[index]
            )
          } else {
            isAddStartMin = 1
          }
        }
        let isExport5Min = 5
        if (index === realityPeriodArr.length - 1 || !item.isInjurFlag) {
          // 最后一个节次不多补5分钟
          isExport5Min = 0
        }
        let diff5interval = item.minMix[1] % 5
        let injuryTime5interval =
          diff5interval === 0
            ? item.minMix[1]
            : item.minMix[1] +
              (isExport5Min > 0 ? this.xAxisTimeInterval - diff5interval : 0)
        injuryTime5interval = injuryTime5interval + isExport5Min
        for (
          let i = item.minMix[0] + isAddStartMin;
          i <= injuryTime5interval;
          i++
        ) {
          // 补分钟，47分钟补到50分钟,这里会补齐分钟刻度值的占位
          xAxisTimeSeriesData.push(i)
        }
        if (isExport5Min > 0) {
          let addDataNum = 0
          if (diff5interval > 0) {
            addDataNum = this.xAxisTimeInterval - diff5interval
          }
          if (isExport5Min > 0) {
            addDataNum = addDataNum + isExport5Min
          }
          const arr = []
          const timeMinArr = []
          let newMax = 0
          for (let i = 0; i < addDataNum; i++) {
            // 补分钟，47分钟补到50分钟,arr补的比赛态势的值；
            // timeMinArr补的是事件对象占位，这样在后面通过取全部事件totalTimeMinArr的索引即可以得到该事件在x轴的坐标值
            arr.push(0)
            timeMinArr.push({
              matchPeriod: index + 1,
              matchMinute: item.minMix[1] + i + 1,
              homeMomentum: 0,
              awayMomentum: 0,
              combinedMomentum: 0,
              goal: null,
              type: null,
            })
            newMax = item.minMix[1] + i + 1
          }
          // 补完5的倍数之后，需要把最大值也同步成最新的minMix，realityPeriod
          item.minMix = [item.minMix[0], newMax]
          item.realityPeriod = [
            item.realityPeriod[0],
            newMax,
            item.realityPeriod[2],
          ]
          totalTimeMinArr[index] = [].concat(totalTimeMinArr[index], timeMinArr)
          homeData[index] = [].concat(homeData[index], arr)
          awayData[index] = [].concat(awayData[index], arr)
        }
      })

      // 总的时间刻度头和尾都需要补一分钟，不然前面的覆盖层无法覆盖2边头和尾的最后一个数据
      xAxisTimeSeriesData.push(
        xAxisTimeSeriesData[xAxisTimeSeriesData.length - 1] + 1
      )

      this.homeData = homeData.flat()
      this.awayData = awayData.flat()
      const allTotalTimeMinArr = []
      totalTimeMinArr.forEach((group) => {
        if (group && group.length > 0) {
          group.forEach((item) => {
            allTotalTimeMinArr.push(item)
          })
        }
      })
      this.totalTimeMinArr = allTotalTimeMinArr
      console.debug('this.homeData:', this.homeData)

      console.debug('realityPeriodArr:', realityPeriodArr, xAxisTimeSeriesData)
      const homeBgData = []
      const awayBgData = []
      const xAxisTimeNumArr = [] //存储时间刻度
      const xAxisData = []
      let prevValue = 0
      let periodIndex = 0
      for (let i = 0; i < xAxisTimeSeriesData.length; i++) {
        xAxisData.push(i)
        homeBgData.push(this.yAxisBaseHeight)
        awayBgData.push(-1 * this.yAxisBaseHeight)
        let realityPeriod = []
        let isInjurFlag = false
        let val = xAxisTimeSeriesData[i]
        if (val > 0) {
          for (let n = periodIndex; n < realityPeriodArr.length; n++) {
            const item = realityPeriodArr[n]
            if (
              item.minMix[0] < val &&
              val <= item.minMix[1] &&
              prevValue >= item.minMix[0]
            ) {
              realityPeriod = item.realityPeriod
              isInjurFlag = item.isInjurFlag
              if (val == realityPeriod[1]) {
                periodIndex++
              }
              break
            }
          }
        }
        console.debug(
          'val:',
          i,
          val,
          isInjurFlag,
          prevValue,
          val % 15,
          realityPeriod,
          realityPeriod[2]
        )
        if (i === 0 || val % 15 === 0) {
          //上半场47分钟，下半场从48分钟开始，48-2-1=45 && 小于等于45分钟时间刻度需要显示，否则都不需要显示
          let value = null
          if (
            realityPeriod.length > 0 &&
            val == realityPeriod[2] &&
            val < realityPeriod[1] &&
            val > realityPeriod[0]
          ) {
            if (prevValue != val) {
              prevValue = val
              value = `${val}+`
            } else {
              value = `${val}`
            }
          } else {
            // if ((i == val && val == 60) || val > 90) {
            //   value = ''
            // } else {
            //   value = `${val}`
            // }
            if (val > realityPeriod[2]) {
              value = ''
            } else {
              value = `${val}`
            }
          }
          console.debug('value:', val, prevValue)
          xAxisTimeNumArr.push({
            name: `id_${i}`,
            value: value,
            xAxis: i,
            yAxis: 0,
            symbol: 'circle',
            // symbolSize: 30,
            label: {
              fontWeight: 'bold',
              fontFamily: 'Qatar2022',
              fontSize: Math.ceil((timeBgWidth / 3) * 2),
              color: this.otherColor[1],
            },
            itemStyle: {
              color: 'transparent',
            },
          })
        } else {
          xAxisTimeNumArr.push({
            name: `id_${i}`,
            // value: i - 1 == 45 ? `${i}+` : `${i}`,
            xAxis: i,
            yAxis: 0,
            symbol: 'circle',
            // symbolSize: 30,
            label: {
              // show: false,
              fontWeight: 'bold',
              fontSize: Math.ceil((timeBgWidth / 3) * 2),
              color: this.otherColor[1],
            },
            itemStyle: {
              color: 'transparent',
            },
          })
        }
      }

      this.xAxisTimeNumArr = xAxisTimeNumArr
      this.xAxisData = xAxisData
      this.homeBgData = homeBgData
      this.awayBgData = awayBgData
      console.debug('homeEventData:', homeEventData)
      this.apiData2echartData(homeEventData, 'home')
      this.apiData2echartData(awayEventData, 'away')
      function periodDataFormatHandler(initArr, injuryArr, maxMinTime) {
        // 自己组装整场比赛的各个阶段的数据，因为后端只吐有数据的每分钟值，未得到不会吐。比如进行上半场30分钟，后端只给30分钟的数据，上半场后面的和下半场需要占位的时间要前端自己组装。
        // 这里处理完后会根据90分钟和120分钟的比赛组装成2个数组（上下半场）或4个数组（上半场、下半场、加时上、加时下）
        let orignArr = initArr,
          baseNum = 0,
          realityNum = 0,
          endNum = 0,
          data = []
        if (maxMinTime == 90) {
          orignArr.length = 2
        }
        orignArr.forEach((initMin, index) => {
          if (index > 0) {
            baseNum = initArr[index - 1]
          }
          let injurMin = injuryArr[index] ? injuryArr[index] : 0
          endNum = initMin
          realityNum = endNum + injurMin
          let periodState = ''
          if (injurMin) {
            if (injurMin > 0) {
              periodState = '3' //补时了
            } else if (injurMin < 0) {
              if (endNum - baseNum > Math.abs(injurMin)) {
                periodState = '2' //该阶段比赛已开始，但未结束
              } else {
                periodState = '1' //该阶段未开始，时间刻度占位置使用
              }
            } else {
              periodState = '4' //整点结束比赛
            }
          } else {
            periodState = '1' //该阶段未开始，时间刻度占位置使用
          }
          data.push({
            realityPeriod: [baseNum, realityNum, endNum], //常规时间：[0,30,45] | 伤停补时2min：[0,47,45]
            minMix: [baseNum, realityNum >= endNum ? realityNum : endNum],
            injurMin: injurMin > 0 ? injurMin + 1 : injurMin,
            isInjurFlag: injurMin >= 0,
            periodState,
          })
        })
        return data
      }
    },
    clickEchartBox(e) {
      console.debug(e)
      if (!this.isMarkFlag) {
        // 清空关键事件
        console.debug('清空关键事件')
      }
      this.isMarkFlag = false
    },
    initEcharts() {
      // 3400/1200 => 3400/1370
      const dom = this.$refs.barEcharts
      const width = dom.clientWidth
      const height = dom.clientHeight
      let timeBgWidth =
        Math.floor(width * 0.035) % 2 == 0
          ? Math.floor(width * 0.035)
          : Math.ceil(width * 0.035)
      const yAxisBaseHeight = this.yAxisBaseHeight
      let echartHPer = Math.round(
        (timeBgWidth * 100 * this.yAxisMaxMin[0]) / height / yAxisBaseHeight
      )
      let topBottom = (100 - echartHPer) / 2
      const yAxisOffset = Math.ceil(width * 0.0053)
      const realityMaxNum = this.realityMaxNum
      console.debug(
        'topBottom:',
        this.yAxisMaxMin,
        realityMaxNum,
        timeBgWidth,
        yAxisBaseHeight,
        echartHPer,
        topBottom
      )
      const allMarkLineData = [].concat(
        this.homeMarkLineData,
        this.awayMarkLineData
      )
      const homeBgData = this.homeBgData
      const awayBgData = this.awayBgData
      const xAxisTimeSeriesData = []
      const xAxisTimeNumArr = this.xAxisTimeNumArr
      const xAxisData = this.xAxisData

      const homeData = this.homeData.map((val, index) => {
        return index === 0 ? 0 : val + (yAxisBaseHeight - 0)
      })
      const awayData = this.awayData.map((val, index) => {
        return index === 0 ? 0 : val - yAxisBaseHeight
      })

      // console.debug(homeData, awayData, homeBgData, topBottom)
      let option = {
        title: {
          show: false,
          text: '比赛态势及关键事件',
        },
        animation: !this.isAutoExportPng,
        tooltip: {
          show: false,
          trigger: 'axis',
        },
        grid: {
          top: `${topBottom}%`,
          bottm: `${topBottom}%`,
          left: '4%',
          right: '4%',
          width: '92%',
          height: `${echartHPer}%`,
        },
        // dataZoom: {
        //   show: true,
        //   type: 'inside',
        //   zoomLock: true,
        // },
        legend: {
          show: false,
        },
        xAxis: [
          {
            // type: 'category',
            boundaryGap: false,
            axisLine: {
              show: true,
              // symbol: ['none', 'arrow'],
              // symbolSize: [6, 6],
              // symbolOffset: [-6, 6],
              lineStyle: {
                width: timeBgWidth,
                color: this.otherColor[0],
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            data: xAxisData,
          },
        ],
        yAxis: {
          boundaryGap: false,
          max: this.yAxisMaxMin[0],
          min: this.yAxisMaxMin[1],
          interval: 5,
          // offset: yAxisOffset,
          axisLabel: {
            show: false,
            formatter: '{value}',
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            // symbol: 'arrow',
            // symbolSize: [6, 6],
            // symbolOffset: [-6, 6],
          },
        },
        series: [
          {
            name: '每分钟占位', //每分钟占位
            type: 'line',
            areaStyle: {
              opacity: 0,
            },
            smooth: true,
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            markLine: {
              silent: true,
              symbol: 'none',
              label: {
                show: false,
              },
              lineStyle: {
                color: this.otherColor[0],
                type: 'solid',
                width: Math.floor(
                  this.$refs.barEcharts.clientWidth > 1000
                    ? this.$refs.barEcharts.clientWidth / 1000
                    : 1
                ),
              },
              // data: [
              //   [
              //     {
              //       name: '起点',
              //       xAxis: 1,
              //       yAxis: 0,
              //     },
              //     {
              //       name: '终点',
              //       xAxis: 1,
              //       yAxis: -75,
              //     },
              //   ],
              //   [
              //     {
              //       name: '8起',
              //       xAxis: 8,
              //       yAxis: 42,
              //     },
              //     {
              //       name: '8终',
              //       xAxis: 8,
              //       yAxis: 75,
              //     },
              //   ],
              //   [
              //     {
              //       name: '起点',
              //       xAxis: 90,
              //       yAxis: 0,
              //       symbolOffset: [2, 0],
              //     },
              //     {
              //       name: '终点',
              //       xAxis: 90,
              //       yAxis: -75,
              //       symbolOffset: [2, 0],
              //     },
              //   ],
              //   [
              //     {
              //       name: 'home_起点',
              //       xAxis: 1,
              //       yAxis: 0,
              //     },
              //     {
              //       name: 'home_终点',
              //       xAxis: 1,
              //       yAxis: 75,
              //     },
              //   ],
              // ],
              data: allMarkLineData,
            },
            data: xAxisTimeSeriesData,
          },
          {
            name: 'homeBar', //主队值 大于0
            type: 'bar',
            data: homeData,
            xAxisIndex: 0,
            barCategoryGap: '10%',
            markPoint: {
              // data: [
              //   {
              //     name: 'val1',
              //     // value: 11,
              //     xAxis: 1,
              //     yAxis: 78,
              //     symbolSize: 40,
              //     symbolOffset: [0, '50%'],
              //     symbol: this.iconBase64.point,
              //   },
              //   {
              //     name: 'val2',
              //     // value: 11,
              //     xAxis: 2,
              //     yAxis: 78,
              //     symbolSize: 40,
              //     symbolOffset: [0, 0],
              //     symbol: this.iconBase64.goal,
              //   },
              //   {
              //     name: 'val2',
              //     // value: 11,
              //     xAxis: 8,
              //     yAxis: 78,
              //     symbolSize: 40,
              //     symbolOffset: [0, 0],
              //     symbol: this.iconBase64.goal,
              //   },
              // ],
              data: this.homeMarkPointData,
            },
            itemStyle: {
              color: this.homeBgColor[1],
              borderRadius: [10, 10, 0, 0],
            },
            smooth: true,
            emphasis: {
              disabled: true,
            },
            animationDuration: function (idx) {
              // 越往后的数据时长越大
              return idx * 15
            },
            animationDelay: 0.5 * 1000,
          },
          {
            name: 'awayBar', //客队值 小于0
            type: 'bar',
            data: awayData,
            barGap: '-100%',
            xAxisIndex: 0,
            barCategoryGap: '10%',
            markPoint: {
              label: {
                shwo: true,
              },
              // data: [
              //   {
              //     name: '周最低',
              //     // value: -11,
              //     xAxis: 90,
              //     yAxis: -78,
              //     symbolSize: 40,
              //     // symbolOffset: [0, 0],
              //     symbol: this.iconBase64.ownGoal,
              //   },
              // ],
              data: this.awayMarkPointData,
            },
            itemStyle: {
              color: this.awayBgColor[1],
              borderRadius: [0, 0, 10, 10],
            },
            smooth: true,
            emphasis: {
              disabled: true,
            },
            animationDuration: function (idx) {
              // 越往后的数据时长越大
              return idx * 15
            },
            animationDelay: 0.5 * 1000,
          },
          {
            name: 'timeHomeBar', //主队覆盖
            type: 'line',
            data: homeBgData,
            xAxisIndex: 0,
            animation: false,
            markPoint: {
              label: {
                shwo: true,
              },
              data: xAxisTimeNumArr, //中间区域的时间数字
            },
            areaStyle: {
              color: this.otherColor[0],
              opacity: 1,
            },
            smooth: true,
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
          },
          {
            name: 'timeAwayBar', //客队覆盖
            type: 'line',
            data: awayBgData,
            xAxisIndex: 0,
            animation: false,
            areaStyle: {
              color: this.otherColor[0],
              opacity: 1,
            },
            smooth: true,
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
          },
        ],
      }
      this.myChart = this.$echarts.init(this.$refs.barEcharts)
      this.myChart.setOption(option)

      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(this.$refs.barEcharts, true, 'uploadData')
        }, 5 * 1000)
      }
    },
    apiData2echartData(arr, state) {
      // 生成echarts数据
      // console.debug("生成echarts数据:", arr);
      // const yAxisMaxNum = 1
      const yAxisBaseHeight = this.yAxisBaseHeight
      console.debug('yAxisBaseHeight:', this.yAxisBaseHeight)

      if (!arr && arr.length == 0) {
        return
      }
      const clientWidth = this.$refs.barEcharts.clientWidth
      const eventIconSize = Math.round((3.6 / 100) * clientWidth)
      let newEventData = []
      const markPointData = []
      const markLineData = []
      // const timeMinArr = [];
      // const repeatTimeMinArr = []
      // const replaceEvent = [];
      const replaceData = []
      const otherEvent = []
      arr.forEach((event) => {
        let newEvent = {}
        if (event.eventCodeWeb == this.eventReplaceCode) {
          newEvent = {
            eventId: `${event.homeAway}_${event.eventId}`,
            eventCodeWeb: this.eventReplaceCode,
            eventName: '换人',
            homeAway: event.homeAway,
            teamName:
              event.homeAway == 'HOME'
                ? this.combatObj[0].name
                : this.combatObj[1].name,
            teamLogo:
              event.homeAway == 'HOME'
                ? this.combatObj[0].logo
                : this.combatObj[1].logo,
            playerName: [
              event.relatePlayerName ? event.relatePlayerName : '',
              event.playerName ? event.playerName : '',
            ],
            timeMin: event.timeMin,
            // xAxis: event.timeMin
          }
          replaceData.push(newEvent)
        } else {
          newEvent = event
          newEvent.teamName =
            event.homeAway == 'HOME'
              ? this.combatObj[0].name
              : this.combatObj[1].name
          newEvent.teamLogo =
            event.homeAway == 'HOME'
              ? this.combatObj[0].logo
              : this.combatObj[1].logo
          otherEvent.push(newEvent)
        }
      })

      newEventData = [].concat(otherEvent, replaceData).sort((a, b) => {
        return a.timeMin - b.timeMin
      })
      if (newEventData.length > 0) {
        const totalTimeMinArr = this.totalTimeMinArr
        newEventData.forEach((event) => {
          let xAxis = 0
          let originEvent = null
          for (let i = 0; i < totalTimeMinArr.length; i++) {
            const cell = totalTimeMinArr[i]
            if (
              cell.matchPeriod == event.matchPeriod &&
              cell.timeMin == event.timeMin
            ) {
              xAxis = i
              originEvent = cell
              break
            }
          }
          let dir = `${event.homeAway === 'HOME' ? 1 : -1}`
          // combinedMomentum 为了保证事件图标下面的竖线一个高度，如果主队的值不是正整数则从0开始画，否则是负数相加可能会去客队一侧；同理客队的不是负数也是从0开始画
          // let combinedMomentum =
          //   event.homeAway === 'HOME'
          //     ? originEvent.combinedMomentum > 0
          //       ? originEvent.combinedMomentum
          //       : 0
          //     : originEvent.combinedMomentum < 0
          //     ? originEvent.combinedMomentum
          //     : 0

          let combinedMomentum =
            event.homeAway === 'HOME'
              ? this.realityMaxNum
              : -1 * this.realityMaxNum

          let markYAxis = Math.abs(combinedMomentum + dir * yAxisBaseHeight)
          const yAxisEventIconHeight =
            Math.round(yAxisBaseHeight * 2 * 0.8 * 100) / 100
          let isBoundary = false
          console.debug(
            'originEvent_pre:',
            markYAxis,
            yAxisBaseHeight,
            yAxisEventIconHeight,
            originEvent.combinedMomentum,
            combinedMomentum,
            markYAxis + 2 * yAxisEventIconHeight
          )

          // markYAxis = markYAxis + 1.5 * yAxisEventIconHeight
          markYAxis = markYAxis + 0
          console.debug(
            'originEvent:',
            originEvent,
            eventIconSize,
            this.yAxisMaxMin,
            markYAxis,
            isBoundary,
            yAxisBaseHeight,
            dir
          )

          markPointData.push({
            name: event.xAxistimeMinId,
            //   value: 11,
            xAxis,
            yAxis: dir * markYAxis,
            symbolSize: eventIconSize,
            // symbolOffset: [0, `${event.homeAway === 'HOME' ? '50%' : '-50%'}`],
            // symbolOffset: [0, `${event.homeAway === 'HOME' ? '-50%' : '50%'}`], //图标分布向上和向下移一半
            symbol:
              this.iconBase64[this.eventCodeWeb2eventKey(event.eventCodeWeb)],
          })

          // markLineData.push([
          //   {
          //     name: '起点',
          //     xAxis,
          //     yAxis: originEvent ? combinedMomentum + dir * yAxisBaseHeight : 0,
          //   },
          //   {
          //     name: '终点',
          //     xAxis,
          //     yAxis:
          //       combinedMomentum +
          //       dir *
          //         (yAxisBaseHeight +
          //           (isBoundary ? 0 : yAxisEventIconHeight / 2)),
          //   },
          // ])
        })
      }
      console.debug(
        'newEventData:',
        newEventData,
        markPointData,
        markLineData,
        arr
      )
      if (state == 'home') {
        this.homeNewEventData = newEventData
        this.homeMarkPointData = markPointData
        this.homeMarkLineData = markLineData
        console.debug('homeMarkPointData:', markPointData, markLineData)
      }
      if (state == 'away') {
        this.awayNewEventData = newEventData
        this.awayMarkPointData = markPointData
        console.debug(this.awayMarkPointData)
        this.awayMarkLineData = markLineData
      }
    },
    eventCode2eventCodeWeb(num) {
      //后端code to 前端code
      let key = null
      switch (num) {
        case 1:
          key = 1
          break
        case 2:
          key = 0
          break
        case 3:
          key = 2
          break
        case 19:
          key = this.eventReplaceCode
          break
        default:
          key = null
          break
      }
      return key
    },
    eventCodeWeb2eventKey(num) {
      let key = ''
      switch (num) {
        case 0:
          key = 'point'
          break
        case 1:
          key = 'goal'
          break
        case 2:
          key = 'ownGoal'
          break
        case 3:
          key = 'offStage'
          break
        case 4:
          key = 'yellowCard'
          break
        case 5:
          key = 'redCard'
          break
        case 6:
          key = 'onStage'
          break
        case 7:
          key = 'yellow2red'
          break
        case this.eventReplaceCode:
          key = 'replace'
          break
        default:
          key = null
          break
      }
      return key
    },
  },
}
</script>

<style lang="scss" scoped>
.matchState_keyEvent_bar {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  &.autoExportPng {
    width: 100%;
    height: 100%;
  }
  .barEcharts {
    width: 100%;
    height: 100%;
    .xAxisTip {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 2% 0 4%;
      width: 100%;
      height: 2.778vw;
      font-size: 0.972vw;
      span {
        width: 2.778vw;
        /* text-align: center; */
        &:last-child {
          width: 0.556vw;
        }
      }
    }
    .barEchartsDom {
      height: calc(100% - 2.778vw);
      width: 100%;
    }
  }
}
</style>
